/*
  Create Your Piece — shell (10A.07: "route, state, progress orchestration").

  Owns the one state object and the step. Everything else listens:
    PersonaCYP.on('state', ({ state, prev, changed }) => …)
    PersonaCYP.on('step',  ({ step, prev }) => …)
  and asks for changes through PersonaCYP.set(patch) / PersonaCYP.go(step).

  Route: /pages/create-your-piece?sport=&piece=&finish=&type=&kind=&value=&font=&crest=&step=
  - Every value is validated against the assortment read from the store.
    Unknown or impossible values are dropped one by one, never fatal.
  - The landing step is derived from the state; `step` can only pull it back.
  - Step changes push history (Back/Forward walk the steps); choices within a
    step replace it (a refresh or a shared link reopens exactly here).
  - The URL is mirrored into sessionStorage so reopening the builder in the
    same session resumes where the customer stopped. Start over (top bar,
    every step but Entry) asks first, then clears the state and that storage
    and returns to Entry.
  - Snap-to-fit (Paper 10.30): the page never scrolls; each step's option
    list scrolls inside the panel, with a fade and a thin indicator.

  Modules register with PersonaCYP.use(fn); they run once the DOM is ready,
  before the first render.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-pb]');
  if (!root || window.PersonaCYP) return;

  var ORDER = ['0', '1', '2', '3', '4', '4b', '5'];
  var FONTS = { arial: 'Arial', palatino: 'Palatino', corsiva: 'Monotype Corsiva', college: 'College Block', times: 'Times New Roman' };
  var KINDS = { number: 'Player number', initials: 'Initials', name: 'Name', namenum: 'Name + number', custom: 'Custom text' };
  var KINDS_A = ['number', 'initials', 'name', 'namenum', 'custom'];
  var KINDS_B = ['initials', 'number'];
  var FAMILIES = ['necklace', 'cuban', 'beaded', 'curb'];
  var STEP_NAMES = { 1: 'Sport', 2: 'Piece', 3: 'Finish', 4: 'Personalize', 5: 'Your Piece' };
  var ALLOWED = /^[A-Za-z0-9 .#&'-]*$/;
  var TIERS = {
    none: /no\s*engrav|^none/i,
    t13: /1\s*[-–]\s*3/,
    t410: /4\s*[-–]\s*10/,
    crest: /logo|crest/i
  };
  var STORE_KEY = 'persona-cyp';
  var bus = document.createElement('span');
  var modules = [];

  var raw = {};
  try { raw = JSON.parse(root.querySelector('[data-pb-data]').textContent); } catch (e) { raw = { sports: [], settings: {} }; }
  var S = raw.settings || {};

  /* ------------------------------------------------------------ catalogue */

  function finishOptionIndex(p) {
    for (var i = 0; i < p.options.length; i++) if (/^(finish|metal|colou?r)$/i.test(p.options[i])) return i;
    return -1;
  }
  function optionIndex(p, re) {
    for (var i = 0; i < p.options.length; i++) if (re.test(p.options[i])) return i;
    return -1;
  }

  var sports = (raw.sports || []).map(function (sp) {
    var byFam = {};
    (sp.products || []).forEach(function (p) {
      var piece = byFam[p.family] || (byFam[p.family] = { family: p.family, name: '', finishes: {}, order: [] });
      var fi = finishOptionIndex(p);
      function add(label, extra) {
        var key = String(label || '').toLowerCase();
        if (!key || piece.finishes[key]) return;
        piece.finishes[key] = Object.assign({ key: key, label: label, product: p, optIndex: -1, optValue: null }, extra || {});
        piece.order.push(key);
        if (!piece.name || key === 'gold') piece.name = p.name;
      }
      if (fi >= 0) {
        p.variants.forEach(function (v) { add(v.options[fi], { optIndex: fi, optValue: v.options[fi] }); });
      } else {
        add(p.finish || 'Gold');
      }
    });
    var pieces = FAMILIES.filter(function (f) { return byFam[f]; }).map(function (f) {
      var pc = byFam[f];
      pc.order.sort(function (a, b) { return (a === 'gold' ? 0 : a === 'silver' ? 1 : 2) - (b === 'gold' ? 0 : b === 'silver' ? 1 : 2); });
      return pc;
    });
    return { slug: sp.slug, name: sp.name, sub: sp.sub, single: sp.single, collection: sp.collection, pieces: pieces };
  });

  function sportBy(slug) { for (var i = 0; i < sports.length; i++) if (sports[i].slug === slug) return sports[i]; return null; }
  function pieceBy(s) {
    var sp = sportBy(s.sport); if (!sp) return null;
    for (var i = 0; i < sp.pieces.length; i++) if (sp.pieces[i].family === s.piece) return sp.pieces[i];
    return null;
  }
  function finishEntry(s, key) {
    var pc = pieceBy(s); if (!pc) return null;
    key = key || s.finish;
    return pc.finishes[key] || pc.finishes[pc.order[0]] || null;
  }
  function variantsFor(fe) {
    var vs = fe.product.variants;
    if (fe.optIndex >= 0) vs = vs.filter(function (v) { return v.options[fe.optIndex] === fe.optValue; });
    return vs;
  }
  function persIndex(p) { return optionIndex(p, /personali[sz]ation/i); }
  function firstOf(vs) { for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i]; return vs[0] || null; }
  function tierVariant(fe, tier) {
    var vs = variantsFor(fe);
    var pi = persIndex(fe.product);
    if (pi < 0) return firstOf(vs);
    var base = firstOf(vs.filter(function (v) { return TIERS.none.test(v.options[pi]); })) || firstOf(vs);
    if (tier === 'none' || !base) return base;
    var same = vs.filter(function (v) {
      if (!TIERS[tier].test(v.options[pi])) return false;
      for (var i = 0; i < v.options.length; i++) if (i !== pi && v.options[i] !== base.options[i]) return false;
      return true;
    });
    return same[0] || firstOf(vs.filter(function (v) { return TIERS[tier].test(v.options[pi]); })) || base;
  }
  function finishAvailable(fe) { return variantsFor(fe).some(function (v) { return v.available; }); }

  function model(family) { return family === 'curb' ? 'B' : 'A'; }
  function limit(family) { return model(family) === 'B' ? (S.curb_limit || 2) : (S.text_limit || 10); }
  function kindsFor(family) { return model(family) === 'B' ? KINDS_B : KINDS_A; }
  function textTier(s) { return (s.value || '').length >= 4 ? 't410' : 't13'; }
  function textProblem(s) {
    var v = s.value || '';
    if (!v.trim()) return 'empty';
    if (!ALLOWED.test(v)) return 'chars';
    if (v.length > limit(s.piece)) return 'long';
    return '';
  }

  /* Price is derived, never stored: the real variant price for the chosen
     finish and personalization tier. */
  function quote(s, over) {
    s = Object.assign({}, s, over || {});
    var fe = finishEntry(s); if (!fe) return null;
    var base = tierVariant(fe, 'none'); if (!base) return null;
    var hasP = persIndex(fe.product) >= 0;
    var tier = s.type === 'text' ? textTier(s) : s.type === 'crest' ? 'crest' : 'none';
    var v = hasP ? tierVariant(fe, tier) : base;
    return { base: base.price, total: v.price, delta: v.price - base.price, hasP: hasP, variant: v, entry: fe, tier: tier };
  }
  function optionPrices(s) {
    var fe = finishEntry(s); if (!fe) return null;
    if (persIndex(fe.product) < 0) return null;
    var base = tierVariant(fe, 'none').price;
    return {
      none: 0,
      t13: tierVariant(fe, 't13').price - base,
      t410: tierVariant(fe, 't410').price - base,
      crest: tierVariant(fe, 'crest').price - base
    };
  }

  function money(cents) {
    var fmt = raw.money_format || '${{amount}}';
    var n = (cents || 0) / 100;
    function group(x, dec, th) {
      var parts = x.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(th === '.' ? ',' : '.');
    }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return group(n, 0, ',');
      if (k === 'amount_with_comma_separator') return group(n, 2, '.');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.');
      return group(n, 2, ',');
    });
    return out.replace(/[.,]00(?!\d)/, '');
  }

  /* ------------------------------------------------------------ state */

  var blank = { sport: null, piece: null, finish: null, type: null, kind: null, value: '', font: 'arial', crest: null };
  var state = Object.assign({}, blank);
  var step = '0';

  function validate(s) {
    var out = Object.assign({}, blank);
    var sp = sportBy(s.sport);
    if (!sp) return out;
    out.sport = sp.slug;
    var pc = null;
    sp.pieces.forEach(function (p) { if (p.family === s.piece) pc = p; });
    if (pc) out.piece = pc.family;
    var f = s.finish ? String(s.finish).toLowerCase() : null;
    if (f && (pc ? pc.finishes[f] : (f === 'gold' || f === 'silver'))) out.finish = f;
    if (s.type === 'none' || s.type === 'text' || s.type === 'crest') out.type = s.type;
    out.value = typeof s.value === 'string' ? s.value.replace(/[\u0000-\u001f]/g, '') : '';
    // accept the key (college) or the name the product page uses (College Block)
    var fk = FONTS[s.font] ? s.font : Object.keys(FONTS).filter(function (k) { return String(FONTS[k]).toLowerCase() === String(s.font || '').toLowerCase(); })[0];
    out.font = fk || 'arial';
    var kinds = kindsFor(out.piece);
    out.kind = kinds.indexOf(s.kind) >= 0 ? s.kind : kinds[0];
    if (out.type === 'crest' && (s.crest === 'upload' || (s.crest === 'later' && S.send_later))) out.crest = s.crest;
    return out;
  }

  function landing(s) {
    if (!s.sport) return '1';
    if (!s.piece) return '2';
    if (!s.finish) return '3';
    if (!s.type) return '4';
    if (s.type === 'none') return '5';
    if (s.type === 'text') return textProblem(s) ? '4b' : '5';
    return s.crest ? '5' : '4b';
  }
  function idx(st) { return ORDER.indexOf(st); }

  function toQuery(s, st) {
    var q = new URLSearchParams();
    if (s.sport) q.set('sport', s.sport);
    if (s.piece) q.set('piece', s.piece);
    if (s.finish) q.set('finish', s.finish);
    if (s.type) q.set('type', s.type);
    if (s.type === 'text') {
      q.set('kind', s.kind);
      if (s.value) q.set('value', s.value);
      q.set('font', s.font);
    }
    if (s.type === 'crest' && s.crest) q.set('crest', s.crest);
    if (st !== '0' || s.sport) q.set('step', st);
    var str = q.toString();
    return str ? '?' + str : '';
  }

  function fromQuery(search) {
    var q = new URLSearchParams(search);
    var s = validate({
      sport: q.get('sport'), piece: q.get('piece'), finish: q.get('finish'), type: q.get('type'),
      kind: q.get('kind'), value: q.get('value') || '', font: q.get('font'), crest: q.get('crest')
    });
    var land = landing(s);
    var want = q.get('step');
    var st = land;
    var any = ['sport', 'piece', 'finish', 'type', 'value', 'step'].some(function (k) { return q.has(k); });
    if (!any) st = '0';
    else if (want && idx(want) >= 0 && idx(want) <= idx(land)) {
      st = want;
      if (st === '4b' && s.type !== 'text' && s.type !== 'crest') st = '4';
    }
    return { state: s, step: st };
  }

  /* ------------------------------------------------------------ session */

  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  var session = readSession();
  function save() {
    session.q = toQuery(state, step);
    try {
      // Nothing chosen: keep only where Close returns to, never a stale flow.
      if (!session.q) {
        if (session.ret) sessionStorage.setItem(STORE_KEY, JSON.stringify({ ret: session.ret }));
        else sessionStorage.removeItem(STORE_KEY);
        return;
      }
      sessionStorage.setItem(STORE_KEY, JSON.stringify(session));
    } catch (e) { /* private mode: state still lives in the URL */ }
  }

  /* ------------------------------------------------------------ bus */

  function emit(name, detail) { bus.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  function on(name, fn) { bus.addEventListener(name, function (e) { fn(e.detail); }); }

  function publicState() {
    var q = quote(state);
    var fe = finishEntry(state);
    return {
      sport: state.sport, piece: state.piece, product: fe && state.piece ? fe.product.handle : null,
      finish: state.finish, personalization_type: state.type, value_length: (state.value || '').length,
      font: state.type === 'text' ? FONTS[state.font] : null, price: q ? q.total / 100 : null, step: step
    };
  }

  var openedAt = Date.now();
  function track(name, extra) {
    var detail = Object.assign({ event: name, state: publicState() }, extra || {});
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail }));
      root.dispatchEvent(new CustomEvent('cyp:analytics', { detail: detail, bubbles: true }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, detail));
    } catch (e) { /* analytics never breaks the flow */ }
  }

  var live = root.querySelector('[data-pb-live]');
  function announce(text) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 60);
  }

  /* ------------------------------------------------------------ confirm */

  var dlg = root.querySelector('[data-pb-confirm]');
  function confirmBox(message, okLabel, cancelLabel) {
    return new Promise(function (resolve) {
      var back = document.activeElement;
      var ok = dlg.querySelector('[data-confirm-ok]');
      var cancel = dlg.querySelector('[data-confirm-cancel]');
      dlg.querySelector('[data-confirm-msg]').textContent = message;
      ok.textContent = okLabel;
      cancel.textContent = cancelLabel;
      dlg.hidden = false;
      ok.focus();
      function done(v) {
        dlg.hidden = true;
        ok.removeEventListener('click', yes);
        cancel.removeEventListener('click', no);
        dlg.removeEventListener('keydown', key);
        if (back && back.focus) back.focus();
        resolve(v);
      }
      function yes() { done(true); }
      function no() { done(false); }
      function key(e) {
        if (e.key === 'Escape') { e.preventDefault(); no(); }
        if (e.key === 'Tab') {
          e.preventDefault();
          (document.activeElement === ok ? cancel : ok).focus();
        }
      }
      ok.addEventListener('click', yes);
      cancel.addEventListener('click', no);
      dlg.addEventListener('keydown', key);
    });
  }

  /* ------------------------------------------------------------ images + drawn back */

  function sized(src, w) {
    if (!src) return src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function imageFor(s, key) {
    var fe = finishEntry(s, key);
    if (!fe) return null;
    if (fe.optIndex >= 0) {
      var vs = fe.product.variants;
      for (var i = 0; i < vs.length; i++) if (vs[i].options[fe.optIndex] === fe.optValue && vs[i].img) return vs[i].img;
    }
    return fe.product.img[0];
  }
  // The sport's lead piece (necklace first, gold first) — its tile photo.
  function leadImage(sp) {
    if (!sp || !sp.pieces.length) return null;
    var pc = sp.pieces[0];
    return imageFor({ sport: sp.slug, piece: pc.family }, pc.order[0]);
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* The back, drawn until back photography lands (Paper 10.35): a flat plate
     in the finish colour — a portrait pendant for necklaces, a bar plate for
     cuban, beaded and curb — with a dashed engrave area carrying the live
     text in the chosen font, or a dashed crest outline. */
  var SHIELD = '<svg class="bk__shield" viewBox="0 0 104 124" aria-hidden="true" focusable="false"><path d="M52 3 L100 18 V58 C100 88 78 110 52 121 C26 110 4 88 4 58 V18 Z" fill="none" stroke-width="2" stroke-dasharray="6 4" vector-effect="non-scaling-stroke"/></svg>';
  var CHAIN = '<svg class="bk__chain" viewBox="0 0 200 96" aria-hidden="true" focusable="false"><path d="M8 0 C 40 40, 80 70, 100 78 M192 0 C 160 40, 120 70, 100 78" fill="none" stroke-width="2.4" stroke-dasharray="5 3"/><circle cx="100" cy="84" r="9" fill="none" stroke-width="3"/></svg>';
  var STUB_L = '<svg class="bk__chain" viewBox="0 0 80 40" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M0 10 C 28 14, 56 19, 80 20" fill="none" stroke-width="2.4" stroke-dasharray="5 3" vector-effect="non-scaling-stroke"/></svg>';
  var STUB_R = '<svg class="bk__chain" viewBox="0 0 80 40" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M80 10 C 52 14, 24 19, 0 20" fill="none" stroke-width="2.4" stroke-dasharray="5 3" vector-effect="non-scaling-stroke"/></svg>';
  function backPlate(s) {
    var bar = !!s.piece && s.piece !== 'necklace';
    var fin = s.finish === 'silver' ? 'silver' : 'gold';
    var inner, plain = false;
    if (s.type === 'text') {
      inner = s.value
        ? '<span class="bk__text pb-ff--' + (FONTS[s.font] ? s.font : 'arial') + '" data-bk-fit>' + esc(s.value) + '</span>'
        : '<span class="bk__label bk__label--soft">Your engraving</span>';
    } else if (s.type === 'crest') {
      inner = SHIELD + '<span class="bk__label">Your crest</span>';
    } else if (s.type === 'none') {
      inner = '<span class="bk__label bk__label--soft">No engraving</span>';
      plain = true;
    } else {
      inner = '<span class="bk__label bk__label--soft">Engrave area</span>';
    }
    var plate = '<div class="bk__plate"><div class="bk__area' + (plain ? ' bk__area--plain' : '') + '">' + inner + '</div></div>';
    return '<div class="bk bk--' + (bar ? 'bar' : 'pendant') + ' bk--' + fin + '">' +
      (bar ? STUB_L + plate + STUB_R : CHAIN + plate) + '</div>';
  }
  // Size the engraving to its area: as large as the drawing allows, never clipped.
  function fitBack(scope) {
    (scope || root).querySelectorAll('[data-bk-fit]').forEach(function (el) {
      var area = el.parentNode, plate = area.parentNode;
      var aw = area.clientWidth, ah = area.clientHeight;
      if (!aw || !ah) return;
      var bar = plate.parentNode.classList.contains('bk--bar');
      var fs = Math.max(8, plate.clientHeight * (bar ? 0.5 : 0.33));
      el.style.fontSize = fs + 'px';
      var guard = 0;
      while ((el.scrollWidth > aw * 0.88 || el.offsetHeight > ah * 0.92) && fs > 8 && guard++ < 40) {
        fs *= 0.92;
        el.style.fontSize = fs + 'px';
      }
    });
  }

  /* ------------------------------------------------------------ in-panel scroll */

  var scrollers = [];
  function wireScroll(sc) {
    var body = sc.parentNode;
    var fade = document.createElement('span');
    fade.className = 'pb-fade';
    fade.setAttribute('aria-hidden', 'true');
    var bar = document.createElement('span');
    bar.className = 'pb-sbar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'pb-sbar__thumb';
    bar.appendChild(thumb);
    body.appendChild(fade);
    body.appendChild(bar);
    function update() {
      var h = sc.clientHeight, H = sc.scrollHeight, t = sc.scrollTop;
      var can = H > h + 2;
      body.classList.toggle('is-scrollable', can);
      body.classList.toggle('is-more', can && H - h - t > 2);
      if (can) {
        var track = bar.clientHeight || h;
        var th = Math.max(24, Math.round(track * h / H));
        thumb.style.height = th + 'px';
        thumb.style.transform = 'translateY(' + Math.round((track - th) * (t / (H - h))) + 'px)';
      }
    }
    sc.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(sc);
      Array.prototype.forEach.call(sc.children, function (c) { ro.observe(c); });
    }
    scrollers.push({ sc: sc, update: update });
  }
  root.querySelectorAll('[data-pb-scroll]').forEach(wireScroll);
  var scrollRaf = 0;
  function refreshScroll() {
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function () {
      scrollRaf = 0;
      scrollers.forEach(function (x) { x.update(); });
    });
  }
  window.addEventListener('resize', refreshScroll);

  /* ------------------------------------------------------------ start over (10.37) */

  var so = root.querySelector('[data-pb-so]');
  var soOpen = root.querySelector('[data-pb-so-open]');
  var soKeep = so && so.querySelector('.pb-so__keep');
  var soGo = so && so.querySelector('[data-so-confirm]');
  var soReturn = null;
  function openStartOver(from) {
    if (!so || step === '0') return;
    soReturn = from || soOpen;
    so.hidden = false;
    soOpen.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pb-lock');
    soKeep.focus();
    track('start_over_opened', { from_step: step });
  }
  function closeStartOver(restore) {
    if (!so || so.hidden) return;
    so.hidden = true;
    soOpen.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pb-lock');
    if (restore !== false) {
      var to = soReturn && soReturn.isConnected && !soReturn.disabled && soReturn.offsetParent !== null ? soReturn : soOpen;
      if (to && to.focus) to.focus();
    }
  }
  function startOver() {
    track('start_over', { from_step: step });
    state = Object.assign({}, blank);
    Object.keys(session).forEach(function (k) { if (k !== 'ret') delete session[k]; });
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* nothing stored */ }
    go('0');
    emit('state', { state: state, prev: state, changed: Object.keys(state) });
    announce('Started over. Your choices were cleared.');
  }
  if (so) {
    soOpen.addEventListener('click', function () { openStartOver(soOpen); });
    so.addEventListener('click', function (e) {
      if (e.target.closest('[data-so-confirm]')) { closeStartOver(false); startOver(); return; }
      if (e.target.closest('[data-so-cancel]')) closeStartOver(true);
    });
    so.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeStartOver(true); return; }
      if (e.key === 'Tab') {
        e.preventDefault();
        (document.activeElement === soKeep ? soGo : soKeep).focus();
      }
    });
  }

  /* ------------------------------------------------------------ render */

  function layoutFor(st) {
    if (st === '0') return 'entry';
    if (st === '5') return 'reveal';
    if (st === '3') return 'finish';
    if (st === '2') {
      var sp = sportBy(state.sport);
      if (sp && sp.pieces.length === 1) return 'single';
    }
    return 'split';
  }

  function showPanels() {
    root.dataset.step = step;
    root.dataset.layout = layoutFor(step);
    root.dataset.type = state.type || '';
    root.querySelectorAll('[data-pb-step]').forEach(function (el) {
      var match = el.getAttribute('data-pb-step') === step;
      var kind = el.getAttribute('data-pb-kind');
      if (match && kind) match = kind === state.type;
      el.hidden = !match;
    });
    var back = root.querySelector('[data-pb-back]');
    if (back) back.hidden = step === '0';
    if (soOpen) soOpen.disabled = step === '0';
  }

  function activeHeading() {
    var panels = root.querySelectorAll('[data-pb-step]');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].hidden) continue;
      var hs = panels[i].querySelectorAll('[data-pb-heading]');
      for (var j = 0; j < hs.length; j++) if (hs[j].offsetParent !== null) return hs[j];
    }
    return null;
  }

  // Our keys are rewritten; anything else in the query (view, preview,
  // campaign tags) is left alone.
  var KEYS = ['sport', 'piece', 'finish', 'type', 'kind', 'value', 'font', 'crest', 'step'];
  function writeURL(push) {
    var q = new URLSearchParams(location.search);
    KEYS.forEach(function (k) { q.delete(k); });
    new URLSearchParams(toQuery(state, step)).forEach(function (v, k) { q.set(k, v); });
    var str = q.toString();
    var url = location.pathname + (str ? '?' + str : '') + location.hash;
    var hs = { cyp: true, step: step };
    try {
      if (push) history.pushState(hs, '', url);
      else history.replaceState(hs, '', url);
    } catch (e) { /* sandboxed previews */ }
    save();
  }

  function set(patch, opts) {
    opts = opts || {};
    var prev = Object.assign({}, state);
    var next = Object.assign({}, state, patch);
    if ('sport' in patch && patch.sport !== prev.sport && !('piece' in patch)) next.piece = null;
    state = validate(next);
    var changed = Object.keys(state).filter(function (k) { return state[k] !== prev[k]; });
    if (!changed.length && !opts.force) return;
    showPanels();
    if (!opts.silent) writeURL(false);
    emit('state', { state: state, prev: prev, changed: changed });
  }

  function go(st, opts) {
    opts = opts || {};
    if (idx(st) < 0) return;
    var prev = step;
    step = st;
    showPanels();
    if (opts.url !== false) writeURL(opts.push !== false);
    emit('step', { step: step, prev: prev });
    if (st === '5' && !session.completed) {
      session.completed = true; save();
      track('builder_completed', { time_in_flow: Math.round((Date.now() - openedAt) / 1000) });
    }
    if (prev !== st) scrollers.forEach(function (x) { x.sc.scrollTop = 0; });
    refreshScroll();
    if (opts.focus !== false) {
      window.scrollTo(0, 0);
      var h = activeHeading();
      if (h) window.requestAnimationFrame(function () { h.focus({ preventScroll: true }); });
    }
  }

  function prevStep() {
    switch (step) {
      case '1': return '0';
      case '2': return '1';
      case '3': return '2';
      case '4': return '3';
      case '4b': return '4';
      case '5': return state.type === 'none' || !state.type ? '4' : '4b';
      default: return '0';
    }
  }

  /* ------------------------------------------------------------ chrome */

  var closeLink = root.querySelector('[data-pb-close]');
  (function returnUrl() {
    if (!session.ret) {
      try {
        var ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.origin === location.origin && ref.pathname !== location.pathname) session.ret = ref.pathname + ref.search;
      } catch (e) { /* no referrer */ }
    }
    if (session.ret && closeLink) closeLink.href = session.ret;
  })();

  function exitTrack() {
    track('builder_exit', { last_step: step, time_in_flow: Math.round((Date.now() - openedAt) / 1000) });
    save();
  }
  if (closeLink) closeLink.addEventListener('click', exitTrack);
  var browse = root.querySelector('[data-pb-browse]');
  if (browse) browse.addEventListener('click', exitTrack);

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pb-back]');
    if (b) { e.preventDefault(); go(prevStep()); return; }
    var begin = e.target.closest('[data-pb-begin]');
    if (begin) { e.preventDefault(); go(state.sport ? landing(state) : '1'); return; }
    var g = e.target.closest('[data-goto]');
    if (g) { e.preventDefault(); go(g.getAttribute('data-goto')); }
  });

  /* Back / Forward walk the steps; they never undo choices. The step comes
     from the history entry, the state stays what the customer has now
     ("Never clear a field silently"). */
  window.addEventListener('popstate', function () {
    var want = new URLSearchParams(location.search).get('step') || '0';
    var land = landing(state);
    var st = idx(want) >= 0 ? want : land;
    if (st !== '0' && idx(st) > idx(land)) st = land;
    if (st === '4b' && state.type !== 'text' && state.type !== 'crest') st = '4';
    var prevStepV = step;
    step = st;
    showPanels();
    writeURL(false);
    emit('step', { step: step, prev: prevStepV });
    closeStartOver(false);
    refreshScroll();
    var h = activeHeading();
    if (h) h.focus({ preventScroll: true });
  });

  /* ------------------------------------------------------------ api */

  window.PersonaCYP = {
    root: root,
    settings: S,
    sports: sports,
    FONTS: FONTS,
    KINDS: KINDS,
    STEP_NAMES: STEP_NAMES,
    ALLOWED: ALLOWED,
    get state() { return state; },
    get step() { return step; },
    session: session,
    save: save,
    on: on,
    emit: emit,
    use: function (fn) { modules.push(fn); },
    set: set,
    go: go,
    landing: function () { return landing(state); },
    track: track,
    announce: announce,
    confirm: confirmBox,
    money: money,
    sportBy: sportBy,
    pieceBy: function (s) { return pieceBy(s || state); },
    finishEntry: function (s, key) { return finishEntry(s || state, key); },
    finishAvailable: finishAvailable,
    quote: function (s, over) { return quote(s || state, over); },
    optionPrices: function (s) { return optionPrices(s || state); },
    model: model,
    limit: limit,
    kindsFor: kindsFor,
    textProblem: function (s) { return textProblem(s || state); },
    isMobile: function () { return window.matchMedia('(max-width: 989px)').matches; },
    reducedMotion: function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; },

    /* The hand-off (shared contract with the product page):
       /products/{handle}[?variant=] + finish, length, type, value, font, from. */
    pdpUrl: function (s) {
      s = s || state;
      var q = quote(s); if (!q) return null;
      var fe = q.entry, v = q.variant;
      var u = new URL(fe.optIndex >= 0 ? v.url : fe.product.url, location.origin);
      u.searchParams.set('finish', fe.key);
      var li = optionIndex(fe.product, /length/i);
      if (li >= 0) u.searchParams.set('length', v.options[li]);
      u.searchParams.set('type', s.type || 'none');
      if (s.type === 'text') {
        u.searchParams.set('value', s.value);
        u.searchParams.set('font', FONTS[s.font]);
      }
      if (s.type === 'crest' && s.crest === 'later') u.searchParams.set('crest', 'later');
      u.searchParams.set('from', 'builder');
      return u.pathname + u.search;
    },

    // Asks first (10.37). The edit sheet's "Start over" routes here too.
    requestStartOver: openStartOver,
    startOver: startOver,
    sized: sized,
    imageFor: function (s, key) { return imageFor(s || state, key); },
    leadImage: leadImage,
    backPlate: function (s) { return backPlate(s || state); },
    fitBack: fitBack,
    refreshScroll: refreshScroll,
    esc: esc
  };

  /* ------------------------------------------------------------ boot */

  function boot() {
    var search = location.search;
    var params = new URLSearchParams(search);
    var hasState = ['sport', 'piece', 'finish', 'type', 'value', 'step'].some(function (k) { return params.has(k); });
    if (!hasState && session.q) search = session.q; // resume this session
    var r = fromQuery(search);
    state = r.state;
    step = r.step;
    modules.forEach(function (fn) { try { fn(window.PersonaCYP); } catch (e) { if (window.console) console.error(e); } });
    showPanels();
    writeURL(false);
    emit('state', { state: state, prev: Object.assign({}, blank), changed: Object.keys(state), initial: true });
    emit('step', { step: step, prev: null, initial: true });
    refreshScroll();
    root.classList.add('is-ready');
    var from = params.get('from');
    track('create_piece_open', { entry_point: from || (session.ret ? 'referral' : 'direct'), device: window.PersonaCYP.isMobile() ? 'mobile' : 'desktop' });
  }

  // Deferred scripts all run before DOMContentLoaded, so every module has
  // registered by the time this fires.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', boot);
  else window.setTimeout(boot, 0);
})();
